import { render, staticRenderFns } from "./carrelloListaProdotti.vue?vue&type=template&id=7c03cf01&"
import script from "./carrelloListaProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloListaProdotti.vue.ts?vue&type=script&lang=ts&"
import style0 from "./carrelloListaProdotti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports